import { instance } from '@/services/avik-api-gateway'
import { PenaltyAssessment } from '@/types/penalty-assessment'
import { AxiosResponse } from 'axios'

export function deleteEventPenaltyAssessment(
  uuid: string
): Promise<AxiosResponse<PenaltyAssessment>> {
  return instance.delete(`/event-penalty-assessment/${uuid}`)
}
